import { render, staticRenderFns } from "./report-batch.vue?vue&type=template&id=c2f851e0&scoped=true&"
import script from "./report-batch.vue?vue&type=script&lang=js&"
export * from "./report-batch.vue?vue&type=script&lang=js&"
import style0 from "./report-batch.vue?vue&type=style&index=0&id=c2f851e0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2f851e0",
  null
  
)

export default component.exports